/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import {
	IconLink,
	Link,
	LinkUI,
	Plugin
} from 'ckeditor5';

export class CustomLinkProvider extends Plugin {
	public static get requires() {
		return [ Link ] as const;
	}

	public static get pluginName() {
		return 'CustomLinkProvider' as const;
	}

	public async init(): Promise<void> {
		const linkUI = this.editor.plugins.get( LinkUI );

		linkUI.registerLinksListProvider( {
			label: 'CKEditor 5 links',
			getListItems: () => [
				{
					id: 'website',
					href: 'https://ckeditor.com',
					label: 'Website',
					icon: IconLink
				},
				{
					id: 'docs',
					href: 'https://ckeditor.com/docs/ckeditor5/latest/index.html',
					label: 'Docs',
					icon: IconLink
				},
				{
					id: 'builder',
					href: 'https://ckeditor.com/ckeditor-5/builder/',
					label: 'Builder',
					icon: IconLink
				},
				{
					id: 'demos',
					href: 'https://ckeditor.com/ckeditor-5/demo/',
					label: 'Demos',
					icon: IconLink
				}
			]
		} );
	}
}
